const mEditionProductPagesOfGratefulnessModalDelete = {
  mEditionProductPagesOfGratefulnessModalDelete: {
    alerts: {
      deleteProductoPaginaIdroop: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'La página de agradecimiento se eliminó exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará la página de agradecimiento ',
      options: 'y todas sus características de forma definitiva.',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: 'Eliminar Página de Agradecimiento'
  }
}

export default mEditionProductPagesOfGratefulnessModalDelete
